import React from "react";
import "./ListingCard.css";
import { Link } from "react-router-dom";

function ListingCard({ listing }) {
  const typesText = {
    residence: "Rezidans",
    villa: "Villa",
    store: "Dükkan & Mağaza",
  };

  return (
    <Link
      to={`/project/${listing.id}`}
      rel="noopener noreferrer"
      className="listing-card listing-card-link"
    >
      <div className="card-image">
        <img src={listing.image} alt={listing.title} />
      </div>
      <div className="card-detail-wrapper">
        <div className="card-location">
          <i className="fa-solid fa-location-dot"></i> {listing.location}
        </div>
        <div className="card-content">
          <div className="title">{listing.title}</div>
          <div className="district">{listing.district}</div>
        </div>
        <div className="card-details">
          <div>
            <div className="d-flex justify-content-evenly">
              <div>
                <i className="fa-solid fa-house"></i>{" "}
                {typesText[listing.details.buldingType]}
              </div>
              <div>
                <i className="fa-solid fa-ruler"></i> {listing.details.square} m
                <sub>2</sub>
              </div>
            </div>
            <div className="d-flex justify-content-evenly">
              <div>
                <i className="fa-solid fa-layer-group"></i>{" "}
                {listing.details.floor}. Kat
              </div>
              <div>
                <i className="fa-solid fa-couch"></i> {listing.details.room}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default ListingCard;
